import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { authLogin } from "../../../api/authApi";

import styles from "./login.module.css";

function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get('adminToken');
    if (token) {
      navigate('/');
    }
  }, [navigate]);

  const [emailOrMobile, setEmailOrMobile] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    if (!emailOrMobile.trim()) {
      newErrors.emailOrMobile = "Email or mobile number is required";
    } else if (
      !emailRegex.test(emailOrMobile) &&
      !mobileRegex.test(emailOrMobile)
    ) {
      newErrors.emailOrMobile =
        "Enter a valid email or 10-digit mobile number";
    }

    if (!password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async () => {
    if (!validate()) return;

    setLoading(true);
    try {
      const payload = { password };
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (emailRegex.test(emailOrMobile)) {
        payload.email = emailOrMobile;
      } else {
        payload.mobileNumber = emailOrMobile;
      }

      const result = await authLogin(payload);

      if (result?.data?.token) {
        Cookies.set('adminToken', result?.data?.token || '', { expires: 30 });
        Cookies.set('adminUserData', JSON.stringify(result?.data?.user) || '', { expires: 30 });

        navigate("/");
      }
    } catch (err) {
      if (err?.status === 401) {
        setErrors({ errors, api: err?.response?.data?.error?.message || "Invalid credentials " });
      }
    }
    setLoading(false);
  };

  const clearError = (field) => {
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <section className={styles.wrapper}>
      <div className={styles.card}>
        <h2 className={styles.title}>Login</h2>
        <div className={styles.formContainer}>
          <div className={styles.formGroup}>
            <input
              type="text"
              placeholder="Email Address"
              value={emailOrMobile}
              onChange={(e) => {
                setEmailOrMobile(e.target.value);
                clearError("emailOrMobile");
              }}
            />
            {errors.emailOrMobile && (
              <p className="error-message">{errors.emailOrMobile}</p>
            )}
          </div>

          <div className={styles.formGroup}>
            <input
              type={"password"}
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                clearError("password");
              }}
            />
            {errors.password && (
              <p className="error-message">{errors.password}</p>
            )}
          </div>
        </div>

        {errors.api && <p className='error-message'>{errors.api}</p>}

        <button
          className={styles.loginBtn}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? <div className="ringLoader"></div> : "Login"}
        </button>


      </div>


    </section>
  );
}

export default Login;
